import styled from "styled-components";

export const BottomContainer = styled.div(({ theme }) => ({
    position: "fixed",
    width: "100%",
    bottom: "0",
    zIndex: 100,
    borderTop: `1px solid ${theme.colors[theme.colorMode].background_Tertiary}`,
}));
